import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none">
      <polyline fill="#A596FF" points="31.907 .032 31.907 8.001 23.955 15.952 23.955 7.967 31.907 .032"/>
      <polyline fill="#333" points="16.003 .032 16.003 8.001 23.955 15.952 23.955 7.967 16.003 .032"/>
      <polyline fill="#A596FF" points="31.923 31.855 23.955 31.855 16.003 23.904 23.988 23.904 31.923 31.855"/>
      <polyline fill="#333" points="31.923 15.952 23.955 15.952 16.003 23.904 23.988 23.904 31.923 15.952"/>
      <polyline fill="#A596FF" points=".1 31.872 .1 23.904 8.052 15.952 8.052 23.937 .1 31.872"/>
      <polyline fill="#333" points="16.004 31.872 16.004 23.904 8.052 15.952 8.052 23.937 16.004 31.872"/>
      <polyline fill="#A596FF" points=".084 .048 8.052 .048 16.004 8 8.019 8 .084 .048"/>
      <polyline fill="#333" points=".084 15.952 8.052 15.952 16.004 8 8.019 8 .084 15.952"/>
    </g>
  </svg>

);
